import { put, select, takeLatest } from 'redux-saga/effects'
import { throwApiException } from '../../../features/zollApi/store/zollApi.actions'
import { getSearchStateSelector } from '../selectors'
import { setFilteredOptions } from '../store/search.actions'
import { SearchConstants } from '../store/search.constants'

export function* setInitialSearchOptions() {
  try {
    const { options } = yield select(getSearchStateSelector)
    yield put(setFilteredOptions(options))
  } catch (e: any) {
    yield put(throwApiException(`setInitialSearchOptions() error: ${e}`))
  }
}

export function* setInitialSearchOptionsSaga() {
  yield takeLatest([SearchConstants.INITIALIZE_SEARCH], setInitialSearchOptions)
}
